import React from 'react';
import { Link } from 'react-router-dom';
import { showNotification } from './../../../utils';

const TemplatesP4 = (props) => {
    const handleSearch = () => {
        if (props.search === '') {
            return showNotification('Enter a value', 'Enter a text to search', 'info');
        }

        props.history.push('/search/' + props.productType + '/' + props.search);
    };

    const keyPressHandler = (event) => {
        if (event.key === 'Enter') {
            if (props.search === '') {
                return showNotification('Enter a value', 'Enter a text to search', 'info');
            }

            props.history.push('/search/' + props.productType + '/' + props.search);
        }
    }

    return (
        <div className="templates-container">
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> / Notecards
            </div>
            <div className="search-container">
                <div className="search-field">
                    <input
                        type="text"
                        placeholder="Search here..."
                        value={props.search}
                        onChange={(event) => props.setSearch(event.target.value)}
                        onKeyPress={keyPressHandler}
                    />
                    <select
                        value={props.productType}
                        onChange={(event) => props.setProductType(event.target.value)}
                    >
                        <option value="1">Cards</option>
                        <option value="17">Pocket Folders</option>
                        <option value="2">Letterheads</option>
                        <option value="3">Envelopes</option>
                        <option value="4">Notecards</option>
                        <option value="18">Notepads</option>
                        <option value="5">Forms</option>
                        <option value="7">Adult Apparel</option>
                        <option value="8">Promotional</option>
                        {/* <option value="16">Marketing</option> */}
                    </select>
                    <div className="button" onClick={handleSearch}>Search</div>
                </div>
            </div>
            <div className="templates-row">
                <div className="category">
                    <Link to="/template/4/3"><div className="image p4-t3"></div></Link>
                    <div className="title">
                        <div className="name">A6 Folded Notecard</div>
                        <div className="button-container">
                            <Link to="/template/4/3"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/myuthealth/4/10"><div className="image p14-t6"></div></Link>
                    <div className="title">
                        <div className="name">Multipurpose Thank You Note Card</div>
                        <div className="button-container">
                            <Link to="/myuthealth/4/10"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TemplatesP4;
